<template>
  <div>
    <div class="my-4 d-flex" style="gap: 1rem;">
      <v-btn
        variant="flat"
        color="primary"
        @click="() => isImportDialogOpen = true"
      >{{ $t('childDevelopment.importRecords') }}</v-btn>
      <v-btn
        variant="outlined"
        color="primary"
        @click="exportFile('domainField')"
      >{{ $t('childDevelopment.exportDomainFields') }}</v-btn>
      <v-btn
        variant="outlined"
        color="primary"
        @click="exportFile('fieldClass')"
      >{{ $t('childDevelopment.exportFieldClass') }}</v-btn>
      <v-spacer />
      <!-- <v-btn
        variant="outlined"
        color="primary"
        @click="updateDevelopmentRecords"
        :loading="isFetching"
      >分析を更新</v-btn> -->
    </div>
    <div
      style="width: 160px;"
      class="ma-2"
    >
      <v-text-field
        hide-details
        density="compact"
        variant="outlined"
        type="number"
        v-model="year"
        :suffix="$t('childDevelopment.fiscalYear')"
      ></v-text-field>
    </div>
    <v-progress-linear
      v-if="isFetching"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <v-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t('childDevelopment.className') }}
            </th>
            <th class="text-left">
              {{ $t('childDevelopment.age') }}
            </th>
            <th></th>
            <!-- 発達記録Excel出力（Vue3対応完了後に対応するため一時コメントアウト）　　　　feat(child-development): excel exports -->
            <th class="text-left">{{ $t('childDevelopment.excelOutput') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="c in classes"
            :key="c.nurseryClass.classId"
          >
            <td>{{ c.nurseryClass.className }}</td>
            <td>{{ c.nurseryClass.childrenAge }}</td>
            <!-- <td>{{ formatDate(c.lastUpdatedAt) }}</td> -->
            <td>
              <v-btn
                color="primary"
                variant="outlined"
                :to="`/child-development/class/${year}/${c.nurseryClass.classId}`"
              >
                {{ $t('childDevelopment.edit') }}
              </v-btn>
            </td>
            <td>
              <div class="d-flex align-center" style="gap: 0.5rem;">
                <!-- 発達記録Excel出力（Vue3対応完了後に対応するため一時コメントアウト）　　　　feat(child-development): excel exports -->
                <!--
                <v-btn
                  small
                  color="primary"
                  rounded
                  variant="flat"
                  @click="openFile(c.recordPdfPath)"
                >
                  <v-icon small left>mdi-file-excel-outline</v-icon>
                  発達記録表出力
                </v-btn>
                <v-btn
                  small
                  color="primary"
                  rounded
                  variant="flat"
                  @click="openFile(c.analysisCsvPath)"
                >
                  表のみ出力
                </v-btn>
                <v-btn
                  v-if="c.analysisGraphPath"
                  small
                  color="primary"
                  rounded
                  variant="flat"
                  @click="openFile(c.analysisGraphPath)"
                >
                  グラフのみ出力
                </v-btn>
                -->
                <v-btn
                  color="primary"
                  rounded
                  :loading="exportingClassId === c.nurseryClass.classId && exportingType === 'development'"
                  @click="exportChildDevelopment(c.nurseryClass.classId)"
                >
                  <v-icon class="me-0" size="18">mdi-file-excel-outline</v-icon>
                  {{ $t('childDevelopment.exportDevelopmentSheet') }}
                </v-btn>
                <v-btn
                  color="primary"
                  rounded
                  :loading="exportingClassId === c.nurseryClass.classId && exportingType === 'record'"
                  @click="exportChildDevelopmentRecord(c.nurseryClass.classId)"
                >
                  <v-icon class="me-0" size="18">mdi-file-excel-outline</v-icon>
                  {{ $t('childDevelopment.exportProgressRecord') }}
                </v-btn>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-table>

    <!-- インポートダイアログ -->
     <v-dialog
      max-width="700"
      v-model="isImportDialogOpen"
      @click:outside="closeImportDialog"
    >
      <v-card
        class="pa-4"
      >
        <page-title :value="$t('childDevelopment.importDialog.title')" />

        <div class="my-4">
          <v-file-input
            truncate-length="15"
            accept=".csv"
            :placeholder="$t('childDevelopment.importDialog.selectFile')"
            v-model="importFile"
          ></v-file-input>
        </div>

        <v-radio-group
          v-model="fileType"
          inline
          class="my-4"
        >
          <v-radio
            :label="$t('childDevelopment.importDialog.domainFieldCsv')"
            value="domainField"
          ></v-radio>
          <v-radio
            :label="$t('childDevelopment.importDialog.fieldClassCsv')"
            value="fieldClass"
          ></v-radio>
        </v-radio-group>

        <v-progress-linear v-if="isImportProcessing" indeterminate color="primary" class="my-4" />

        <div class="my-4 d-flex align-center">
          <v-spacer />
          <v-btn
            color="primary"
            variant="flat"
            :disabled="isImportProcessing"
            @click="startImport"
          >{{ $t('childDevelopment.importDialog.startImport') }}</v-btn>
          <v-spacer />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import CommonUtil from '@/utils/CommonUtil';
import dayjs from 'dayjs';
import { defineComponent } from 'vue';
import PageTitle from '@/components/atoms/PageTitle.vue';

import { childDevelopmentsModule } from '@/store/viewModules/child-development/childDevelopmentsModule'
import LocalDataService from '@/service/LocalDataService';
import ApiChildDevelopment from '@/api/ApiChildDevelopment';
import ApiResource from '@/api/ApiResource';

interface DataType {
  isFetching: boolean;
  // showQuitChildren: boolean;
  // showDonwloadMessage: boolean;
  year: number;
  isImportDialogOpen: boolean;
  isImportProcessing: boolean;
  importFile?: File;
  fileType: string;
  watchingTimer: number | null;
  exportingClassId: number | null;
  exportingType: string | null;
}

export default defineComponent({
  components: {
    PageTitle
  },
  data: (): DataType => {
    return {
      isFetching: false,
      year: dayjs().year(),
      isImportDialogOpen: false,
      isImportProcessing: false,
      importFile: undefined,
      fileType: 'domainField',
      watchingTimer: null,
      exportingClassId: null,
      exportingType: null
    }
  },
  computed: {
    classes() {
      return childDevelopmentsModule.classes
    },
    importStatuses() {
      return childDevelopmentsModule.statuses
    }
  },
  methods: {
    async listDevelopmentRecords() {
      this.isFetching = true;
      await childDevelopmentsModule.listClasses({ year: this.year });
      this.isFetching = false;
    },
    async updateDevelopmentRecords() {
      this.isFetching = true;
      await childDevelopmentsModule.updateRecords({ year: this.year });
      await this.listDevelopmentRecords();
      this.isFetching = false;
    },
    async openFile(path: string | null) {
      const nurseryId = LocalDataService.getNurseryId();
      if (path && nurseryId) {
        this.isFetching = true;
        const url = await ApiResource.getDownloadUrl({
          nurseryId,
          path
        })
        this.isFetching = false;
        window.open(url.preSignedDownloadUrl, '_blank')
      }
    },
    formatDate(dateString: string | null) {
      if (!dateString) {
        return this.$t('common.unknown') as string;
      }
      return dayjs(dateString).format('YYYY-MM-DD HH:mm')
    },
    closeImportDialog() {
      this.isImportDialogOpen = false;
    },
    async startImport() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && this.importFile) {
        this.isImportProcessing = true;
        const uploadTargetResponse = await ApiChildDevelopment.getImportUploadUrl({
          nurseryId,
          fileType: this.fileType
        });
        if (uploadTargetResponse) {
          const uploadResponse = await ApiResource.uploadFile({
            url: uploadTargetResponse.preSignedUploadUrl,
            file: this.importFile,
          });
          this.startWatchingStatus({
            statusId: String(uploadTargetResponse.statusId),
            category: uploadTargetResponse.category
          })
          alert('Import started')
        }
        this.isImportProcessing = false;
        this.closeImportDialog();
      }
    },
    startWatchingStatus({
      category,
      statusId,
    }: {
      statusId: string;
      category: string;
    }) {
      this.watchingTimer = setInterval(async () => {
        const response = await childDevelopmentsModule.listImportStatus({
          statusId,
          category
        })

        if (response && response.status === 'success') {
          alert('Import completed successfully')
          this.stopWatchingStatus();
        }

        if (response && response.status === 'failed') {
          alert('Import failed. Please check the file content.')
          this.stopWatchingStatus();
        }
      }, 2500);
    },
    stopWatchingStatus() {
      if (this.watchingTimer) {
        clearInterval(this.watchingTimer)
        this.watchingTimer = null;
      }
    },
    async exportChildDevelopment(classId: number) {
      const nurseryId = LocalDataService.getNurseryId();
      if (!nurseryId) return;
      this.exportingClassId = classId;
      this.exportingType = 'development';
      try {
        const response = await ApiChildDevelopment.exportChildDevelopment({
          nurseryId,
          classId,
          year: this.year,
        });
        if (response) {
          alert(this.$t('ui.exportStarted'));
        } else {
          alert(this.$t('ui.exportFailed'));
        }
      } catch {
        alert(this.$t('ui.exportFailed') as string);
      } finally {
        this.exportingClassId = null;
        this.exportingType = null;
      }
    },
    async exportChildDevelopmentRecord(classId: number) {
      const nurseryId = LocalDataService.getNurseryId();
      if (!nurseryId) return;
      this.exportingClassId = classId;
      this.exportingType = 'record';
      try {
        const response = await ApiChildDevelopment.exportChildDevelopmentRecord({
          nurseryId,
          classId,
          year: this.year,
        });
        if (response) {
          alert(this.$t('ui.exportStarted'));
        } else {
          alert(this.$t('ui.exportFailed'));
        }
      } catch {
        alert(this.$t('ui.exportFailed') as string);
      } finally {
        this.exportingClassId = null;
        this.exportingType = null;
      }
    },
    async exportFile(fileType: string) {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiChildDevelopment.getExportUrl({
          nurseryId,
          fileType
        })

        if (response) {
          window.open(response.preSignedDownloadUrl, '_blank');
        }
      }
    }
  },
  watch: {
    year() {
      this.listDevelopmentRecords();
    }
  },
  mounted() {
    this.year = parseInt(CommonUtil.getFiscalYear(dayjs().format('YYYY-MM')))
    this.listDevelopmentRecords();
  }
})
</script>